import axios from "axios";

const request = axios.create({
  baseURL:
    !process.env.NODE_ENV || process.env.NODE_ENV === "development"
      ? "http://localhost:5001/api/v1"
      : "https://api.bellhopt.com/api/v1",

  withCredentials: true,
});

request.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      const err = {
        error: "No response from the server, please try again later",
      };
      const data = { response: { data: err } };
      return Promise.reject(data);
    }
    // On 401: only clear host auth and redirect when the failed request was to a host endpoint (not driver)
    if (error.response?.status === 401) {
      const requestUrl = error.config?.url ?? "";
      if (requestUrl.includes("/driver/")) {
        // Driver request (e.g. reset password on this domain) — do not clear host; let driver screen handle
        return Promise.reject(error);
      }
      // Host request — clear host auth and redirect to login (PublicLayout, so SideNav is never shown)
      localStorage.removeItem("hostInfo");
      window.location.href = "/login";
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default request;
